import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tw-w-full tw-flex tw-justify-center" }
const _hoisted_2 = {
  class: "tw-card tw-mx-3 tw-border-primary-light tw-flex",
  style: {"border-top-width":"6px","border-top-color":"rgba(1, 149, 135, 1)","width":"min(800px, 100%)"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "tw-w-16 tw-h-16 tw-rounded-full tw-bg-primary-light tw-bg-opacity-10 tw-flex tw-justify-center tw-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-search tw-text-primary-dark",
    style: {"font-size":"24px"}
  })
], -1)
const _hoisted_4 = { class: "tw-flex tw-flex-col tw-justify-between tw-ml-4" }
const _hoisted_5 = { class: "tw-text-xl" }
const _hoisted_6 = { class: "tw-mb-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.title || "Nessun risultato trovato"), 1),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.text || "Prova a modificare i criteri di ricerca"), 1)
      ])
    ])
  ]))
}